;(function() {
  'use strict'

  angular.module('core.glMasonry', [])
})()
